module.exports = __webpack_public_path__ + "img/woman.05dfc3d3.svg";